<template>
	<div tabindex="0" :aria-label="item.name" :alt="item.name"
		class="menu-item-wrapper no-highlight" :class="styleWrapper()"
		@click="handleClickMenuItem" @keydown.enter="handleClickMenuItem">
		<div ref="infoCard" class="info-wrapper" :class="infoStyle()" v-if="displayInfo()">
			<div ref="colorBar" class="item-color-bar"></div>
			<h2 class="item-name truncate">{{ item.name }}</h2>
		</div>
		<div v-if="displayQuickAdd()" class="quick-add-quantity">
			<BaseQuantityButtons
				customType="quick-add-overlay"
				:quantity="itemQuantity"
				@incrementQuantity="increment()"
				@decrementQuantity="decrement()"
				@setInputQuantity="setQuantityFromInput" />
		</div>
		<div v-if="displayQuickAdd()"
			class="quick-add"
			ref="quickAdd"
		>
			<div>Add to cart</div>
		</div>
		<menu-item-image :item="item" />
	</div>
</template>

<script>
	import { delayCall } from '@/utils/helper.functions';
	import cartItemMixin from '@Mixin/cartItemMixin';
	import MenuItemImage from '@/components/menu/MenuItem/MenuItemImage';
	import menuItemQuickAddMixin from '@Mixin/menuItemQuickAddMixin';

	export default {
		components: {
			'menu-item-image': MenuItemImage,
		},
		props: {
			item: {
				type: Object,
			},
			categoryId: {
				type: String,
			},
			click: {
				type: Function,
				default: null,
			},
			afterClick: {
				type: Function,
				default: () => {},
			}
		},
		data() {
			return {
				itemQuantity: 1,
			}
		},
		mixins: [
			cartItemMixin,
			menuItemQuickAddMixin,
		],
		methods: {
			notBundle() {
				const item = this.item;
				const bundle = item.bundle;
				return (!bundle);
			},
			displayInfo() {
				if (this.$mq === 'mobile') {
					return true;
				}
				const notBundle = this.notBundle();
				if (notBundle) {
					return true;
				}
				return false;
			},
			infoStyle() {
				const noOptions = this.displayQuickAdd();
				return {
					'no-options': noOptions,
				}
			},
			styleWrapper() {
				const notBundle = this.notBundle();
				const outOfStock = this.item.outOfStock;
				const showZoom = notBundle && !outOfStock;
				return {
					'zoom': showZoom,
					'no-image': !this.$useItemImages,
					'out-of-stock': outOfStock,
				};
			},
			handleClickMenuItem() {
				const disabled = this.checkDisabled;
				if (!disabled) {
					this.loading = true;
				}
				if (this.displayQuickAdd()) {
					this.handleClickQuickAdd();
					this.loading = false;
					return;
				}
				delayCall(this.handleClick);
			},
			handleItemWithoutImage() {
				if (this.$useItemImages) {
					return;
				}
				const colorBar = this.$refs['colorBar'];
				const { color, topColor } = this.menuItem_getItemColors(this.item);
				colorBar.style.backgroundColor = color;
				const infoCard = this.$refs['infoCard'];
				const itemName = this.item.name;
				const wordLengths = itemName.split(' ').map((word) => word.length);
				const longestLength = Math.max(...wordLengths);
				if (longestLength < 9 && wordLengths.length < 3) {
					const label = infoCard.querySelector('.item-name');
					label.style.fontSize = '1.2em';
				}
			},
			adjustImage() {
				const progressiveImage = this.$refs.progressiveImage;
				const image = progressiveImage.$refs.main;
				const notBundle = this.notBundle();
				if (notBundle) {
					image.style.maxHeight = '174px';
					image.style.objectFit = 'cover';
				}
			},
			loadImage(imageUrl) {
				this.adjustImage();
			},
		},
		mounted() {
			this.handleItemWithoutImage();
		},
		created() {},
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	@import 'commonStyle/menuCard';
	.quick-add {
		@include flex-center;
		position: absolute;
		bottom: 0.5em;
		right: 0.5em;
		border-radius: 4px;
		padding: 0 10px;
		margin: 0;
		max-height: 20px;
		background-color: $storeButtonColor;
		color: $storeButtonTitleColor;
		font-size: 14px;
		font-weight: bold;
		transition: all .33s ease-in-out;
		z-index: $zTopLayer;
		overflow: hidden;
	}
	@include desktop {
		.quick-add-quantity {
			// TODO handle styling
			display: none;
			position: absolute;
			bottom: 1em;
			left: 1em;
			opacity: 0;
			z-index: $zTopInteractionLayer;
		}
		.menu-item-wrapper:hover {
			.quick-add {
				background-color: $storeButtonColorHover;
				box-shadow: $storeButtonTitleColor 0px 0px 6px;
			}
			.quick-add-quantity {
				opacity: 1;
			}
		}
	}
	@include mobile {
		// TODO Add quantity controls to mobile UI
		.quick-add-quantity {
			display: none;
		}
		.info-wrapper {
			margin: 0;

			align-items: center;
			justify-content: center;

			min-height: 4rem;
			&.no-image {
				height: $menu_mobile_card_height;
				width: $menu_mobile_card_width;
				.item-name {
					font-size: 1.2em;
					color: $menu_card_name_color;
				}
				// TODO add config selector
			}
		}
		.menu-item-wrapper {
			max-height: 188px;
			.menu-item-info {
				overflow: hidden;
				.image-wrapper {
					justify-content: center;
					width: 50vw;
					img {
						padding: 0;
						max-height: $menu_mobile_card_height;
					}
				}
				h2 {
					margin: 0;
					position: relative;
					min-height: 2rem;
					max-height: 100%;
					width: 100%;
					font-size: 12pt;
				}
			}
		}
	}

	@include tablet {
        .menu-item-wrapper .menu-item-info .image-wrapper {
			justify-content: none;
        }
        .menu-item-wrapper img {
            width: 90%;
            max-width: 100%;
        }
	}
</style>



// WEBPACK FOOTER //
// src/components/menu/MenuItem/MenuItem.vue